<ng-container [formGroup]="formGroup">

  <div class="row">
    <div class="col-auto align-self-center">
      <h4 class="mb-none">Beneficiaries</h4>
    </div>
    <div class="col pl-none">
      <lds-button
        appearance="default"
        variation="link"
        iconBefore="add"
        (onClick)="add()">
        Add a Beneficiary
      </lds-button>
    </div>
  </div>

  <div formArrayName="beneficiaries">
    <ng-container *ngIf="form.controls.length > 0; else tplNoControls">
      <app-inline-item
        *ngFor="let beneficiaryForm of form.controls; let i = index"
        [form]="beneficiaryForm"
        [formGroupName]="i"
        [isExpandable]="true"
        [initiallyExpanded]="expandedIndex === i"
        (delete)="remove(i)">
        <inline-summary>
          <div class="row">
            <div class="col-9">{{ beneficiaryForm.controls.contact.value?.name }}</div>
            <div class="col">
              {{ beneficiaryForm.controls.ownership.value | percent }}
            </div>
          </div>
        </inline-summary>
        <inline-content>
          <div class="row">
            <div class="col-9">
              <app-contact-search formControlName="contact" label="Beneficiary">
              </app-contact-search>
            </div>

            <div class="col-3">
              <spark-shared-percentage
                formControlName="ownership"
                label="Share"
                [validations]="{
                  custom: 'Must not exceed 100%'
                }">
              </spark-shared-percentage>
            </div>
          </div>
        </inline-content>
      </app-inline-item>
    </ng-container>
    <ng-template #tplNoControls>
      <p>None</p>
    </ng-template>
  </div>
  <lds-form-feedback
    *ngIf="isRequired && form.touched && form.invalid"
    [control]="form"
    [messages]="{
      required: 'At least one beneficiary is required',
      minlength: 'At least one beneficiary is required',
      aggregated: 'Total share must not exceed 100%'
    }">
  </lds-form-feedback>
</ng-container>
